export default "__VITE_ASSET__CQVQZkcz__"